module.exports = __webpack_public_path__ + "img/f1ead56.webp";